// QueryOpinionByPageReq 分页查询意见反馈信息请求
export interface QueryOpinionByPageReq {
    content?: string;
    contact?: string;
    dealt?: number;
    page_num: number;
    page_size: number;
}

export interface OpinionModel {
    id: string;
    user_id: string;
    content: string;
    images: string[];
    contact: string;
    dealt: number;
    handler: string;
    handle_result: string;
    created_at: string;
    updated_at: string;
}

export interface OpinionPaginationData {
    total: number;
    list: OpinionModel[];
}

export interface OpinionPaginationResp {
    code: number;
    msg: string;
    data: OpinionPaginationData;
}

export interface OpinionOpResp {
    code: number;
    msg: string;
    data: string;
}

// 空的分页数据
export const emptyOpinionPaginationData: OpinionPaginationData = {
    total: 0,
    list: []
};

// 空的查询请求
export const emptyQueryOpinionByPageReq: QueryOpinionByPageReq = {
    content: "",
    contact: "",
    dealt: undefined,
    page_num: 1,
    page_size: 10
};

// 分页查询意见反馈
export function queryOpinionByPage(req: QueryOpinionByPageReq, callback: (success: boolean, resp?: OpinionPaginationResp) => void) {
    const {getToken} = require("../util/account");
    const {getWindflowServerBaseUrl} = require("./api");
    
    // 构建查询参数
    const params = new URLSearchParams();
    if (req.content) params.append('content', req.content);
    if (req.contact) params.append('contact', req.contact);
    if (req.dealt !== undefined) params.append('dealt', req.dealt.toString());
    params.append('page_num', req.page_num.toString());
    params.append('page_size', req.page_size.toString());
    
    fetch(getWindflowServerBaseUrl() + "/system/queryOpinionByPage?" + params.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        }
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error("Network response was not ok");
        }
    }).then(data => {
        callback(true, data);
    }).catch(error => {
        console.error("Error:", error);
        callback(false);
    });
}

// 处理意见反馈
export function handleOpinion(id: string, handleResult: string, callback: (success: boolean, resp?: OpinionOpResp) => void) {
    const {getToken} = require("../util/account");
    const {getWindflowServerBaseUrl} = require("./api");
    
    fetch(getWindflowServerBaseUrl() + "/system/handleOpinion", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": getToken()
        },
        body: JSON.stringify({
            id: id,
            handle_result: handleResult
        })
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error("Network response was not ok");
        }
    }).then(data => {
        callback(true, data);
    }).catch(error => {
        console.error("Error:", error);
        callback(false);
    });
}